<template>
  <!--
    Esqueleto del formulario mientras cargan los textos, el catálogo y la configuración:
    tiene la misma forma que el primer paso, así la página no "salta" al aparecer el formulario.
  -->
  <section class="swc" role="status" aria-live="polite" :aria-busy="true">
    <div class="swc__contenedor">
      <div class="swc__barra swc__barra--antetitulo" />
      <div class="swc__progreso"><div class="swc__progreso-barra" /></div>
      <div class="swc__barra swc__barra--paso" />
      <div class="swc__barra swc__barra--titulo" />
      <div class="swc__barra swc__barra--texto" />
      <div class="swc__barra swc__barra--texto swc__barra--corta" />

      <div class="swc__opciones">
        <div v-for="i in 2" :key="i" class="swc__opcion">
          <div class="swc__icono" />
          <div class="swc__lineas">
            <div class="swc__barra swc__barra--opcion" />
            <div class="swc__barra swc__barra--opcion-sub" />
          </div>
        </div>
      </div>

      <p class="swc__mensaje">
        <span class="swc__punto" /><span class="swc__punto" /><span class="swc__punto" />
        <span class="swc__mensaje-texto">{{ texto }}</span>
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ texto?: string }>(), { texto: 'Cargando formulario…' })
</script>

<style lang="scss">
.swc {
  --swc-base: #eceff1;
  --swc-brillo: #f7f8f9;
  padding: 48px 16px 72px;

  &__contenedor { max-width: 760px; margin: 0 auto; }

  &__barra {
    height: 14px;
    border-radius: 7px;
    background: linear-gradient(90deg, var(--swc-base) 25%, var(--swc-brillo) 50%, var(--swc-base) 75%);
    background-size: 200% 100%;
    animation: swc-brillo 1.4s ease-in-out infinite;
    &--antetitulo { width: 180px; height: 10px; margin-bottom: 16px; }
    &--paso { width: 90px; height: 10px; margin: 14px 0 28px; }
    &--titulo { width: 70%; height: 30px; border-radius: 8px; margin-bottom: 18px; }
    &--texto { width: 92%; margin-bottom: 10px; }
    &--corta { width: 55%; margin-bottom: 32px; }
    &--opcion { width: 60%; height: 16px; margin-bottom: 10px; }
    &--opcion-sub { width: 85%; height: 12px; }
  }

  &__progreso { height: 4px; background: var(--swc-base); border-radius: 2px; overflow: hidden; }
  &__progreso-barra {
    width: 30%; height: 100%; border-radius: 2px; background: #c9d1d8;
    animation: swc-progreso 1.6s ease-in-out infinite;
  }

  &__opciones { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 16px; }
  &__opcion {
    display: flex; align-items: center; gap: 16px;
    padding: 20px; border: 1px solid #e3e7ea; border-radius: 12px; background: #fff;
  }
  &__icono {
    flex: 0 0 44px; height: 44px; border-radius: 50%;
    background: linear-gradient(90deg, var(--swc-base) 25%, var(--swc-brillo) 50%, var(--swc-base) 75%);
    background-size: 200% 100%; animation: swc-brillo 1.4s ease-in-out infinite;
  }
  &__lineas { flex: 1; }

  &__mensaje {
    display: flex; align-items: center; justify-content: center; gap: 6px;
    margin: 40px 0 0; color: #5f6b76; font-size: 0.95rem;
  }
  &__mensaje-texto { margin-inline-start: 6px; }
  &__punto {
    width: 6px; height: 6px; border-radius: 50%; background: #9aa5ae;
    animation: swc-punto 1.2s ease-in-out infinite;
    &:nth-child(2) { animation-delay: 0.15s; }
    &:nth-child(3) { animation-delay: 0.3s; }
  }

  @media (prefers-reduced-motion: reduce) {
    .swc__barra, .swc__icono, .swc__progreso-barra, .swc__punto { animation: none; }
  }
}

@keyframes swc-brillo { 0% { background-position: 100% 0; } 100% { background-position: -100% 0; } }
@keyframes swc-progreso { 0% { transform: translateX(-100%); } 100% { transform: translateX(340%); } }
@keyframes swc-punto { 0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); } 40% { opacity: 1; transform: scale(1); } }
</style>
